var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"name":"payment-method","rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('div',{class:{
      'form-control': true,
      'is-select': true,
      'is-invalid': errors.length,
      'vs-wrap-text': true
    }},[_c('v-select',{attrs:{"options":_vm.paymentsList,"disabled":_vm.disabled,"reduce":function (payment) { return payment.id; },"placeholder":"Wybierz metodę płatności","label":"name"},model:{value:(_vm.payment_id),callback:function ($$v) {_vm.payment_id=$$v},expression:"payment_id"}},[_c('template',{slot:"no-options"},[_vm._v(" Brak metod płatności dla tego klienta ")])],2)],1),_c('div',{staticClass:"invalid-feedback"},[_vm._v(" "+_vm._s(errors[0])+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }